<template>
  <el-dialog title="Изменение тарифа" :visible="visible" v-on="$listeners" @close="onClose">
    <el-form id="formServer" label-position="right" label-width="150px">
      <el-form-item label="Тариф">
        <select-tariff :tariff-id="id_tariff" @change="(tariff) => (id_tariff = tariff.id_tariff)" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="onClose">Отменить</el-button>
      <el-button id="submitServer" :loading="requestLoading" type="primary" @click="onSave">Сохранить</el-button>
    </span>
  </el-dialog>
</template>

<script>
import SelectTariff from "@/components/Tariffs/components/feature/SelectTariff";
import camerasDialogsMixin from "@/components/Cameras/components/dialogs/camerasDialogsMixin";
import { ApiService } from "@/api";
export default {
  name: "CamerasTariffDialog",
  components: { SelectTariff },
  mixins: [camerasDialogsMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id_tariff: null,
    };
  },
  methods: {
    onSave() {
      this.save(() => ApiService.cameras.updateCamerasTariff(this.id_tariff, this.cameras));
    },
  },
};
</script>
